import React from 'react';
import {connect} from 'react-redux';
import {ReactSVG} from 'react-svg';

import {provinceList} from '../../../config';
import {
    activateLayer,
    closeDrawModePanel,
    displayDrawModeStartPanel,
    toggleAdhocLayerPanel,
    toggleMobileMenu,
    zoomMapToExtent
} from '../../../actions';
import NavbarMainMenu from './NavbarMainMenu';
import AreaSearch from './AreaSearch';
import CoordinateSearch from './CoordinateSearch';
import NavbarLayerList from './NavbarLayerList';
import {Mobile} from '../Responsive';
import LoginDropdown from './LoginDropdown';
import {trans} from '../../../config/translation';
import Parser from 'html-react-parser';
import {pushGtmSearchProvince} from '../../../config/gtm';
/**
 * Top Navigation Bar React Component
 */
class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.provinceList = provinceList;
    }

    /**
     * Province list render helper from config file
     *
     * @returns {unknown[]}
     */
    renderProvinces() {
        return this.provinceList.map(province => {
            return (
                <div className="dropdown-item" key={province[`name_${window['locale']}`]}>
                    <a href="#" onClick={() => this.provinceClick(province)}
                       role="button">
                        {province[`name_${window['locale']}`]}
                    </a>
                </div>
            );
        });
    }

    /**
     * province click handler
     *
     * @param province
     */
    provinceClick(province) {
        this.props.zoomMapToExtent(province.extent);
        const provinceLayerId = parseInt(process.env.MIX_MAP_PROVINSI_LAYER_ID);
        this.props.layers.map((layerGroup)=>{
            layerGroup.layers.map(layer => {
                if (layer.id === provinceLayerId) {
                    const isActiveLayer = this.props.activeLayers.find(activeLayer => activeLayer.id === provinceLayerId);
                    if (!isActiveLayer) {
                        this.props.activateLayer(layer);
                    }
                }
            });
        });

        /* gtm event processing */
        pushGtmSearchProvince();
    }

    /**
     * mobile menu bar click handler
     *
     * @param $type
     */
    mobileMenuClickHandle($type) {
        this.props.toggleMobileMenu({item: $type});
        if($type === 'draw-mode' || $type === 'adhoc-layer'){
            if($type === 'draw-mode') {
                this.props.displayDrawModeStartPanel({});
            } else if($type === 'adhoc-layer') {
                this.props.toggleAdhocLayerPanel();
            }
        }
        else{
            this.props.closeDrawModePanel();
            this.props.toggleAdhocLayerPanel({status: false});
        }
    }

    render() {
        return (
            <nav id="navbar-top" className="navbar navbar-expand-lg">
                <NavbarMainMenu/>

                <a className="navbar-brand" href="/">
                    {/*<ReactSVG id="navbar-logo" className="react-svg" src="/img/maps/logo.svg"/>*/}
                    <img id="navbar-logo" src="/img/maps/logo.png" alt=""/>
                </a>

                <NavbarLayerList/>

                <div id="navbar-location-finder">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link dropdown-toggle" href="#" role="button"
                               data-toggle="dropdown" data-target="#location-search-dropdown-menu"
                               data-tip={trans('nav.tooltip.find-location')}
                            >
                                <ReactSVG className="location-finder-icon react-svg"
                                          src="/img/maps/icon/location.svg"/>
                            </a>
                            <div className={`dropdown-menu collapse mobile-menu-panel ${this.props.mobileMenu === 'location-search' ? 'show' : ''}`} id="location-search-dropdown-menu">
                                <Mobile>
                                    <div className="mobile-panel-header">
                                        <div className="wrapper">
                                            <div className="title">
                                                <ReactSVG className="location-finder-icon react-svg"
                                                          src="/img/maps/icon/location.svg"/>
                                                <div>Cari lokasi</div>
                                            </div>
                                            <div>
                                                <a className="btn btn-close" href="#" role="button"
                                                   onClick={() => this.props.toggleMobileMenu({item: 'location-search'})}
                                                >
                                                    <ReactSVG className="close-icon react-svg"
                                                              src="/img/maps/icon/close.svg"/>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Mobile>
                                <div className="dropdown-item dropdown-search">
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <a data-toggle="tab" className="nav-link active"
                                               data-target="#search-area-container">{trans('nav.find-location.location')}</a>
                                        </li>
                                        <li className="nav-item">
                                            <a data-toggle="tab" className="nav-link"
                                               data-target="#search-coordinate-container">{trans('nav.find-location.coordinate')}</a>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div id="search-area-container" className="tab-pane fade in active show">
                                            <AreaSearch/>
                                        </div>
                                        <div id="search-coordinate-container" className="tab-pane fade">
                                            <CoordinateSearch/>
                                            <div className="instruction">
                                                {Parser(trans('nav.find-location.coordinate-instruction'))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.renderProvinces()}
                            </div>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link dropdown-toggle" href="#"
                               onClick={() => this.props.displayDrawModeStartPanel({})}
                               data-tip={trans('nav.tooltip.draw-mode')}
                            >
                                <ReactSVG className="react-svg"
                                          src="/img/maps/icon/draw-menu.svg"/>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link dropdown-toggle" href="#"
                               onClick={() => this.props.toggleAdhocLayerPanel()}
                               data-tip={trans('nav.tooltip.add-layer')}
                            >
                                <ReactSVG className="react-svg"
                                          src="/img/maps/icon/add-layer.svg"/>
                            </a>
                        </li>
                    </ul>
                </div>

                <div id="navbar-account">
                    <ul className="navbar-nav">
                        {this.props.user && this.props.user.alias ?
                            <li className="nav-item logged-in">
                                <a href="#" role="button" className="nav-link account-button" data-toggle="dropdown">
                                    <span>
                                        {this.props.user.alias}
                                    </span>
                                </a>
                                <LoginDropdown/>
                            </li>
                            :
                            <li className="nav-item">
                                <a href="#" role="button" className="account-button nav-link dropdown-toggle"
                                   data-toggle="dropdown">
                                    <ReactSVG className="user-icon react-svg" src="/img/maps/icon/user.svg"/>
                                </a>
                                <LoginDropdown/>
                            </li>
                        }
                    </ul>
                </div>

                {/* mobile bottom bar */}
                <Mobile>
                    <div id="mobile-bottom-bar">
                        <ul className="navbar-nav">
                            <li className={`nav-item ${this.props.mobileMenu === 'layers' ? 'active' : ''}`}>
                                <a className="nav-link" href="#" role="button"
                                   // data-toggle="collapse"
                                   // data-target="#navbar-layer-collapse"
                                   onClick={() => this.mobileMenuClickHandle('layers')}
                                >
                                    <ReactSVG className="location-finder-icon react-svg"
                                              src="/img/maps/icon/layers-2.svg"/>
                                </a>
                            </li>
                            <li className={`nav-item ${this.props.mobileMenu === 'legends' ? 'active' : ''}`}>
                                <a className="nav-link" href="#" role="button"
                                   onClick={() => this.mobileMenuClickHandle('legends')}
                                >
                                    <ReactSVG className="location-finder-icon react-svg"
                                              src="/img/maps/icon/layers.svg"/>
                                </a>
                            </li>
                            <li className={`nav-item ${this.props.mobileMenu === 'location-search' ? 'active' : ''}`}>
                                <a className="nav-link" href="#"
                                    // data-toggle="collapse" data-target="#location-search-dropdown-menu"
                                   onClick={() => this.mobileMenuClickHandle('location-search')}
                                >
                                    <ReactSVG className="location-finder-icon react-svg"
                                              src="/img/maps/icon/location.svg"/>
                                </a>
                            </li>
                            <li className={`nav-item ${this.props.mobileMenu === 'draw-mode' ? 'active' : ''}`}>
                                <a className="nav-link" href="#"
                                   onClick={() => this.mobileMenuClickHandle('draw-mode')}
                                >
                                    <ReactSVG className="react-svg"
                                              src="/img/maps/icon/draw-menu.svg"/>
                                </a>
                            </li>
                            <li className={`nav-item ${this.props.mobileMenu === 'adhoc-layer' ? 'active' : ''}`}>
                                <a className="nav-link dropdown-toggle" href="#"
                                   onClick={() => this.mobileMenuClickHandle('adhoc-layer')}>
                                    <ReactSVG className="react-svg"
                                              src="/img/maps/icon/add-layer.svg"/>
                                </a>
                            </li>
                        </ul>
                    </div>
                </Mobile>
            </nav>
        );
    }
}

const mapActionToProps = {
    zoomMapToExtent,
    activateLayer,
    displayDrawModeStartPanel,
    closeDrawModePanel,
    toggleMobileMenu,
    toggleAdhocLayerPanel,
};

const mapStateToProps = state => {
    return {
        layers      : state.layers,
        activeLayers: state.activeLayers,
        mobileMenu  : state.mobileMenu,
        user        : state.user,
    };
};
export default connect(mapStateToProps, mapActionToProps)(Navbar);